<div
  class="toast-container fixed bottom-5 right-5 z-[99999] flex flex-col gap-4 w-96 max-w-[90vw] pointer-events-none"
>
  <div
    *ngFor="let toast of toasts"
    class="toast-card pointer-events-auto transform transition-all duration-300 ease-out animate-slide-in flex items-center py-6 pr-5 pl-8 bg-white relative overflow-hidden rounded-xl"
    [ngClass]="[
      'toast-type-' + toast.type,
      toast.isClosing ? 'animate-slide-out' : 'animate-slide-in',
    ]"
  >
    <div
      class="toast-icon-wrapper flex-shrink-0 mr-4 flex items-center justify-center w-10 h-10 rounded-full"
    >
      <i
        *ngIf="toast.type === 'success'"
        class="pi pi-check text-white font-bold"
        style="font-size: 1.1rem"
      ></i>
      <i
        *ngIf="toast.type === 'error'"
        class="pi pi-times text-white font-bold"
        style="font-size: 1.1rem"
      ></i>
      <i
        *ngIf="toast.type === 'info'"
        class="pi pi-info text-white font-bold"
        style="font-size: 1.1rem"
      ></i>
      <i
        *ngIf="toast.type === 'warning'"
        class="pi pi-exclamation-triangle text-white font-bold"
        style="font-size: 1.1rem"
      ></i>
    </div>

    <div class="flex-1 pt-0.5 pr-6">
      <h4
        class="text-[16px] font-extrabold text-gray-800 m-0 leading-tight tracking-tight"
      >
        {{ toast.title }}
      </h4>
      <p
        *ngIf="toast.message"
        class="text-[13px] text-gray-400 m-0 mt-0.5 leading-normal font-medium"
      >
        {{ toast.message }}
      </p>
    </div>

    <button
      (click)="remove(toast.id)"
      class="absolute top-2 right-2 text-gray-400 hover:text-red-500 transition-colors focus:outline-none py-1 px-2 rounded-lg hover:bg-red-100"
    >
      <i class="pi pi-times" style="font-size: 0.8rem; font-weight: bold"></i>
    </button>
  </div>
</div>
